import { connect } from 'react-redux';
import PitchedRoof from './PitchedRoof';

import { getAnnualResults } from '../../selectors';


const mapStateToProps = state => ({
    horizonLength: state.settings.horizonLength,
    annualResults: getAnnualResults(state),
    firstName: state.contactUI.firstName,
    systemSize: state.solar.systemSize,
    resiToggle: state.tax.resiToggle,
    provider: state.utility.provider,
    projectState: state.projectaddress.projectState,
});

const combinedActions = {
};

export default connect(mapStateToProps, combinedActions)(PitchedRoof);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/PitchedRoof/index.js